/* Creator landing page (ncl-*) — shop-the-look modal, favourites filter,
   mobile sticky CTA, per-ad hero video swap. State machine per the handoff
   README (rows{included,size}, derived totals). Cart add = ONE
   /cart/add.js items[] call, then the nama cart drawer opens (NamaCart).
   Analytics: dataLayer pushes + CustomEvents (look_open / use_her_size /
   piece_toggle / look_added) — the A/B test's measurement hooks. */
(function () {
  var root = document.querySelector('[data-ncl]');
  if (!root) return;

  var dataEl = root.querySelector('[data-ncl-data]');
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = { looks: [], adVariants: {} }; }

  var money = function (cents) {
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  };
  /* Our own SVG stars, never .jdgm-star — that renders through the JudgemeStar
     icon font and custom.css's blanket font-family override turns it into
     letterforms. Fill is fractional so 4.94 doesn't round up to five. */
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.9 6.3 6.9.8' +
    '-5.1 4.7 1.4 6.8L12 18l-6 3.6 1.4-6.8L2.3 9.1l6.9-.8z"/></svg>';
  var STAR_ROW = STAR + STAR + STAR + STAR + STAR;
  function starsMarkup(avg) {
    var pct = Math.max(0, Math.min(100, (avg / 5) * 100));
    return '<span class="ncl-stars"><span class="base">' + STAR_ROW + '</span>' +
      '<span class="fill" style="width:' + pct.toFixed(1) + '%">' + STAR_ROW + '</span></span>';
  }
  function reviewsLabel(avg, n) {
    return avg.toFixed(1) + ' out of 5 stars, ' + n + (n === 1 ? ' review' : ' reviews');
  }

  var track = function (name, detail) {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'ncl_' + name }, detail));
      document.dispatchEvent(new CustomEvent('ncl:' + name, { detail: detail }));
    } catch (e) { /* analytics must never break shopping */ }
  };

  /* ── per-ad swap (?ad=key) ────────────────────────────────────── */
  /* An ad's creative shows ONE outfit. Swapping only the hero video left the
     pieces underneath belonging to look 1 — a shopper clicking a white set
     landed on a grey one. So an ad selects a LOOK, and the video, the look
     bar, which drawer the CTAs open, and the Edit grid all move with it.
     Favourites move too when that ad overrides them.
     Unknown key, or a look title that matches nothing, changes nothing. */
  (function () {
    try {
      var key = new URLSearchParams(location.search).get('ad');
      if (!key) return;
      var v = DATA.adVariants[key.toLowerCase()];
      if (!v) return;
      var li = (v.look === 0 || v.look > 0) ? v.look : null;
      var L = li === null ? null : DATA.looks[li];

      var src = v.video || (L && L.video);
      var vid = root.querySelector('.ncl-banner video');
      if (src && vid) {
        vid.querySelectorAll('source').forEach(function (n) { n.remove(); });
        vid.src = src;
        vid.load();
        var p = vid.play(); if (p && p.catch) p.catch(function () {});
      }

      if (L) {
        /* every control that opens "the hero look" now means this one */
        root.querySelectorAll('.ncl-lk-bar--hero [data-ncl-look], .ncl-lk-bar--hero,' +
          ' [data-ncl-hero-cta] [data-ncl-look], .ncl-close [data-ncl-look],' +
          ' [data-ncl-sticky] [data-ncl-look]').forEach(function (el) {
          if (el.hasAttribute('data-ncl-look')) el.setAttribute('data-ncl-look', li);
        });

        var bar = root.querySelector('.ncl-lk-bar--hero');
        if (bar) {
          var t = bar.querySelector('.ncl-lt b');
          if (t) t.textContent = L.title;
          var meta = bar.querySelector('.ncl-lt > span');
          if (meta) {
            var gross = L.items.reduce(function (a, it) { return a + it.price; }, 0);
            meta.innerHTML = L.items.length + ' pieces · <span data-ncl-lt-total="' +
              gross + '">' + money(gross) + '</span>';
          }
          bar.setAttribute('aria-label', 'Shop ' + L.title);
        }

        /* Edit grids are pre-rendered per look; only the active one is shown */
        var grids = root.querySelectorAll('[data-ncl-edit]');
        if (grids.length) {
          var matched = false;
          grids.forEach(function (g) {
            var on = g.getAttribute('data-ncl-edit') === String(li);
            g.hidden = !on;
            if (on) matched = true;
          });
          if (!matched) grids.forEach(function (g) { g.hidden = g.getAttribute('data-ncl-edit') !== '0'; });
          var cnt = root.querySelector('[data-ncl-edit-count]');
          if (cnt && matched) cnt.textContent = L.items.length + ' pieces';
        }
      }

      if (v.fav) {
        var sets = root.querySelectorAll('[data-ncl-fav]');
        var want = key.toLowerCase();
        var hit = false;
        sets.forEach(function (n) { if (n.getAttribute('data-ncl-fav') === want) hit = true; });
        if (hit) sets.forEach(function (n) { n.hidden = n.getAttribute('data-ncl-fav') !== want; });
      }

      track('ad_variant', { key: key, look: L ? L.title : null });
    } catch (e) { /* a bad param must never cost the page */ }
  })();

  /* ── video autoplay resilience (same contract as split-hero) ──── */
  var vids = root.querySelectorAll('video');
  vids.forEach(function (v) {
    v.muted = true; v.playsInline = true;
    v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.loop = true;
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.25) {
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) { v.pause(); }
    });
  }, { threshold: [0, 0.25] });
  vids.forEach(function (v) { io.observe(v); });
  ['touchend', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      vids.forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight && v.paused) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    }, { passive: true });
  });

  /* ── her discount, live in the session ────────────────────────── */
  /* Every code a shopper has to retype at checkout is a re-decision, so the
     code is activated on arrival instead of advertised. Ads should point at
     /discount/<code>?redirect=<page>; direct and organic hits land here
     without it, so we activate client-side too.
     /discount/<code>?redirect=/cart.js sets the cookie AND hands back the
     cart in one small request — no page-sized HTML download, and the cart is
     how we verify the code is real. Struck-through prices are shown ONLY when
     this succeeded; otherwise the original "use code X" copy stands. */
  var DISCOUNT = {
    code: (DATA.discountCode || '').trim(),
    pct: DATA.discountPercent || 0,
    on: false
  };

  function cookieHas(code) {
    return document.cookie.split('; ').some(function (c) {
      if (c.indexOf('discount_code=') !== 0) return false;
      try { return decodeURIComponent(c.slice(14)).toUpperCase() === code.toUpperCase(); }
      catch (e) { return false; }
    });
  }

  /* `applicable` is only meaningful once the cart holds something — an empty
     cart reports false even for a perfectly valid code — so only a non-empty
     cart is ever allowed to withdraw the promise. */
  function auditCart(cart) {
    if (!cart || !cart.item_count) return;
    var d = (cart.discount_codes || []).filter(function (x) {
      return String(x.code).toUpperCase() === DISCOUNT.code.toUpperCase();
    })[0];
    if (d && d.applicable === false) DISCOUNT.on = false;
  }

  function paintDiscount() {
    var first = DATA.creatorFirst || 'Her';
    root.querySelectorAll('[data-ncl-code]').forEach(function (el) {
      if (el.getAttribute('data-orig') === null) el.setAttribute('data-orig', el.innerHTML);
      if (DISCOUNT.on) {
        el.textContent = first + '’s ' + DISCOUNT.pct + '% off applied';
        el.classList.add('is-on');
      } else {
        el.innerHTML = el.getAttribute('data-orig');
        el.classList.remove('is-on');
      }
    });
    root.querySelectorAll('[data-ncl-lt-total]').forEach(function (el) {
      var gross = parseInt(el.getAttribute('data-ncl-lt-total'), 10);
      if (!(gross > 0)) return;
      if (el.getAttribute('data-orig') === null) el.setAttribute('data-orig', el.innerHTML);
      if (DISCOUNT.on) {
        el.innerHTML = '<s>' + money(gross) + '</s> ' + money(net(gross));
      } else {
        el.innerHTML = el.getAttribute('data-orig');
      }
    });

    var st = root.querySelector('[data-ncl-code-sticky]');
    if (st) {
      if (st.getAttribute('data-orig') === null) st.setAttribute('data-orig', st.textContent);
      st.textContent = DISCOUNT.on ? DISCOUNT.pct + '% off applied' : st.getAttribute('data-orig');
    }
  }

  /* `shopify theme dev` proxies /cart.js fine but answers /discount/* with a
     401, so the code can never actually go live in a localhost session. On
     that host only, treat it as applied so the drawer can be reviewed exactly
     as shoppers will meet it. The hostname check means production can never
     reach this branch — there, a failed activation still falls back to the
     honest "use code X at checkout" copy. */
  function isPreviewHost() {
    return location.hostname === '127.0.0.1' || location.hostname === 'localhost';
  }

  function initDiscount() {
    if (!DISCOUNT.code || !DISCOUNT.pct) return;
    if (cookieHas(DISCOUNT.code)) {          // arrived via /discount/... , or a repeat view
      DISCOUNT.on = true;
      paintDiscount();
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { auditCart(cart); paintDiscount(); if (cur != null) sync(); })
        .catch(function () {});
      return;
    }
    if (DATA.discountAuto === false) return;
    fetch('/discount/' + encodeURIComponent(DISCOUNT.code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        DISCOUNT.on = cookieHas(DISCOUNT.code) || isPreviewHost();
        auditCart(cart);
        paintDiscount();
        if (cur != null) sync();
        if (DISCOUNT.on) track('discount_active', { code: DISCOUNT.code, percent: DISCOUNT.pct });
      })
      .catch(function () {
        if (!isPreviewHost()) return;   // in production the "use code" copy stands
        DISCOUNT.on = true; paintDiscount(); if (cur != null) sync();
      });
  }

  function net(cents) { return DISCOUNT.on ? Math.round(cents * (100 - DISCOUNT.pct) / 100) : cents; }

  /* ── shop-the-look modal ──────────────────────────────────────── */
  var scrim = root.querySelector('[data-ncl-scrim]');
  var sheet = root.querySelector('[data-ncl-sheet]');
  var body = root.querySelector('[data-ncl-sh-body]');
  var countEl = root.querySelector('[data-ncl-sh-count]');
  var wasEl = root.querySelector('[data-ncl-sh-was]');
  var totalEl = root.querySelector('[data-ncl-sh-total]');
  var codeEl = root.querySelector('[data-ncl-sh-code]');
  var alertEl = root.querySelector('[data-ncl-sh-alert]');
  var addBtn = root.querySelector('[data-ncl-sh-add]');
  var noteEl = root.querySelector('[data-ncl-sh-note]');
  var toast = root.querySelector('[data-ncl-toast]');
  var iv = root.querySelector('[data-ncl-iv]');
  var ivStrip = root.querySelector('[data-ncl-iv-strip]');
  var ivDots = root.querySelector('[data-ncl-iv-dots]');
  var ivName = root.querySelector('[data-ncl-iv-name]');
  var ivRev = root.querySelector('[data-ncl-iv-rev]');
  var ivInfo = root.querySelector('[data-ncl-iv-info]');
  var ivScroll = root.querySelector('.ncl-iv-scroll');

  var cur = null;    // active look index
  var rows = [];     // [{ included, size, autoOff, dead, open }]
  var applied = null; // the size last applied across the look, for messaging

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL'];
  /* She may wear a different size top and bottom, so "her size" is a question
     about the garment, not about her. Kept in step with
     snippets/nama-creator-wears.liquid, which answers the same question for
     the product cards. */
  var UPPER = ['tops', 'tanks', 'bras', 'layers'];
  var LOWER = ['leggings', 'shorts', 'pants', 'skirts'];
  function herSizeFor(item) {
    var t = String((item && item.type) || '').toLowerCase();
    if (UPPER.indexOf(t) !== -1 && DATA.herSizeTop) return DATA.herSizeTop;
    if (LOWER.indexOf(t) !== -1 && DATA.herSizeBottom) return DATA.herSizeBottom;
    return DATA.herSize || DATA.herSizeTop || DATA.herSizeBottom || null;
  }

  function sizeAxis(item) {
    for (var i = 0; i < item.options.length; i++) {
      if (/size/i.test(item.options[i].name)) return { pos: i, values: item.options[i].values };
    }
    /* A single-option product is a chooser only when the option is real —
       Shopify's synthetic Title/"Default Title" axis is not something to ask
       a shopper about, and rendering it produced a junk one-chip row. */
    if (item.options.length === 1) {
      var vals = item.options[0].values;
      if (vals.length === 1 && /^default title$/i.test(String(vals[0]).trim())) return null;
      return { pos: 0, values: vals };
    }
    return null;
  }
  function sizeAvailable(item, pos, val) {
    return item.variants.some(function (v) { return v.options[pos] === val && v.available; });
  }
  function anyAvailable(item) {
    return item.variants.some(function (v) { return v.available; });
  }
  function canTake(item, val) {
    var ax = sizeAxis(item);
    if (!ax) return anyAvailable(item);
    return ax.values.indexOf(val) !== -1 && sizeAvailable(item, ax.pos, val);
  }
  function variantFor(item, k) {
    var ax = sizeAxis(item);
    if (!ax) return item.variants.filter(function (v) { return v.available; })[0] || null;
    var want = rows[k].size;
    return item.variants.filter(function (v) { return v.options[ax.pos] === want && v.available; })[0] || null;
  }
  var esc = function (s) { return String(s == null ? '' : s).replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

  /* Apply one size across the whole look. Anything that can't take it is
     dropped OUT of the bundle rather than left blocking the CTA — one
     sold-out piece must never hold the other two hostage. */
  function applySize(val) {
    var L = DATA.looks[cur];
    if (!val || !L) return;
    L.items.forEach(function (it, k) {
      if (rows[k].dead) return;
      var ax = sizeAxis(it);
      if (!ax) return;
      if (canTake(it, val)) {
        rows[k].size = val;
        if (rows[k].autoOff) { rows[k].included = true; rows[k].autoOff = false; }
      } else {
        rows[k].size = null;
        rows[k].included = false;
        rows[k].autoOff = true;
      }
    });
    applied = val;
  }

  /* Like applySize but each piece gets the size she wears for THAT garment.
     Returns the sizes actually used, so the sold-out note can name one only
     when they agree. */
  function applyHerSizes() {
    var L = DATA.looks[cur];
    if (!L) return [];
    var used = [];
    L.items.forEach(function (it, k) {
      if (rows[k].dead) return;
      var ax = sizeAxis(it);
      if (!ax) return;
      var want = herSizeFor(it);
      if (!want) return;
      used.push(want);
      if (canTake(it, want)) {
        rows[k].size = want;
        if (rows[k].autoOff) { rows[k].included = true; rows[k].autoOff = false; }
      } else {
        rows[k].size = null;
        rows[k].included = false;
        rows[k].autoOff = true;
      }
    });
    var uniform = used.length && used.every(function (v) { return v === used[0]; });
    applied = uniform ? used[0] : null;   // null -> the note says "that size"
    return used;
  }

  function rowHtml(it, k) {
    var ax = sizeAxis(it);
    var imgs = (it.images && it.images.length) ? it.images : (it.image ? [it.image] : []);
    var chips = '';
    if (ax) {
      chips = '<div class="ncl-szs" data-ncl-szs hidden>' + ax.values.map(function (val) {
        var ok = sizeAvailable(it, ax.pos, val);
        return '<button type="button" data-ncl-sz="' + esc(val) + '" aria-pressed="false"' +
          (ok ? '' : ' disabled aria-label="' + esc(val) + ', sold out"') + '>' + esc(val) + '</button>';
      }).join('') + '</div>';
    }
    return '<div class="ncl-it" data-ncl-k="' + k + '">' +
      '<button class="ncl-th" type="button" data-ncl-img aria-label="View images of ' + esc(it.name) + '">' +
        '<img src="' + esc(it.image) + '" alt="" loading="lazy">' +
        /* An affordance, never a number: a bare count on a product thumbnail
           reads as stock ("6 left"), which is a far louder claim than "6
           photos" and one we are not making. */
        (imgs.length ? '<span class="ncl-th-z" aria-hidden="true">' +
          '<svg viewBox="0 0 12 12"><path d="M1 4V1h3M8 1h3v3M11 8v3H8M4 11H1V8"/></svg></span>' : '') +
      '</button>' +
      '<div class="ncl-ic">' +
        '<div class="ncl-top"><div class="ncl-nmw">' +
          (it.fabric ? '<p class="ncl-fab">' + esc(it.fabric) + '</p>' : '') +
          '<p class="ncl-nm">' + esc(it.name) + '</p></div>' +
          '<span class="ncl-pr">' + money(it.price) + '</span>' +
        '</div>' +
        '<div class="ncl-act">' +
          (ax
            ? '<span class="ncl-szw"><em class="ncl-szv" data-ncl-szv></em>' +
              '<button class="ncl-szch" type="button" data-ncl-szsel aria-expanded="false"' +
              ' data-ncl-szch></button></span>'
            : '<span class="ncl-szw"><em class="ncl-szv is-none">One size</em></span>') +
          '<button class="ncl-inc" type="button" data-ncl-inc aria-pressed="true">' +
            '<i></i><span data-ncl-inct>Included</span></button>' +
        '</div>' +
      '</div>' + chips + '</div>';
  }

  function openLook(i) {
    var L = DATA.looks[i];
    if (!L) return;
    cur = i;
    rows = L.items.map(function (it) {
      var dead = !anyAvailable(it);
      var ax = sizeAxis(it);
      return {
        included: !dead,
        size: (!dead && !ax) ? 'one' : null,
        autoOff: dead, dead: dead, open: false
      };
    });
    /* The look name is no longer shown — it was a line of chrome above the
       pieces. It still names the dialog, so a screen-reader user opening look
       two can tell it from look three. */
    sheet.setAttribute('aria-label', 'Shop ' + L.title);
    body.innerHTML = L.items.map(rowHtml).join('');

    /* Open on the house default size so the CTA is live immediately. Her
       size becomes an explicit one-tap choice rather than the silent starting
       point — which is also what makes "Use her sizes" do something. */
    applied = null;
    var preset = DATA.defaultSize || DATA.herSize;
    if (preset) applySize(preset);

    sheet.hidden = false;
    sync();
    requestAnimationFrame(function () {
      scrim.classList.add('on');
      sheet.classList.add('on');
      document.body.classList.add('ncl-lock');
    });
    track('look_open', { look: L.title });
  }

  function closeSheet() {
    closeViewer();
    scrim.classList.remove('on');
    sheet.classList.remove('on');
    document.body.classList.remove('ncl-lock');
    setTimeout(function () { sheet.hidden = true; }, 380);
  }

  function sync() {
    var L = DATA.looks[cur];
    if (!L) return;
    var count = 0, gross = 0, needSize = 0;
    rows.forEach(function (r, k) {
      if (!r.included) return;
      if (!r.size) { needSize++; return; }
      count++; gross += L.items[k].price;
    });
    var owed = net(gross);

    /* the size most of the look agrees on, so an odd one out can be flagged */
    var freq = {};
    rows.forEach(function (r) {
      if (r.included && r.size && r.size !== 'one') freq[r.size] = (freq[r.size] || 0) + 1;
    });
    var dominant = Object.keys(freq).sort(function (a, b) { return freq[b] - freq[a]; })[0] || null;

    /* rows */
    Array.prototype.forEach.call(body.children, function (el, k) {
      var r = rows[k], it = L.items[k];
      el.classList.toggle('off', !r.included);
      el.classList.toggle('dead', !!r.dead);
      var szv = el.querySelector('[data-ncl-szv]');
      var szsel = el.querySelector('[data-ncl-szsel]');
      var szch = el.querySelector('[data-ncl-szch]');
      var szs = el.querySelector('[data-ncl-szs]');
      if (szv) {
        szv.textContent = r.size ? 'Size ' + r.size
          : (r.autoOff && applied ? 'Sold out in ' + applied : 'No size selected');
        szv.classList.toggle('is-warn', !r.size);
        /* a row only raises its voice when it is the exception — matching the
           rest of the look, it stays quiet under the global chips */
        szv.classList.toggle('is-odd', !!(dominant && r.size && r.size !== 'one' && r.size !== dominant));
      }
      if (szch) szch.textContent = r.size ? 'Change size' : 'Choose size';
      if (szs) { szs.hidden = !r.open; }
      if (szsel) szsel.setAttribute('aria-expanded', r.open ? 'true' : 'false');
      if (szs) {
        szs.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-ncl-sz') === r.size ? 'true' : 'false');
        });
      }
      var inc = el.querySelector('[data-ncl-inc]');
      var inct = el.querySelector('[data-ncl-inct]');
      if (inc && inct) {
        if (r.dead) {
          inct.textContent = 'Sold out'; inc.disabled = true; inc.setAttribute('aria-pressed', 'false');
          inc.setAttribute('aria-label', it.name + ' is sold out');
        } else {
          inc.disabled = false;
          inct.textContent = r.included ? 'Included' : 'Add';
          inc.setAttribute('aria-pressed', r.included ? 'true' : 'false');
          inc.setAttribute('aria-label', (r.included ? 'Remove ' : 'Add ') + it.name +
            (r.included ? ' from this look' : ' to this look'));
        }
      }
    });

    /* totals + CTA speak the same number */
    countEl.textContent = count + (count === 1 ? ' piece' : ' pieces');
    totalEl.textContent = count ? money(owed) : '—';
    if (wasEl) {
      var showWas = count && DISCOUNT.on && owed !== gross;
      wasEl.hidden = !showWas;
      wasEl.textContent = showWas ? money(gross) : '';
    }
    if (codeEl) {
      var first = DATA.creatorFirst || 'Her';
      codeEl.hidden = !count || !DISCOUNT.pct;
      codeEl.textContent = DISCOUNT.on
        ? first + '’s ' + DISCOUNT.pct + '% off applied'
        : 'Use code ' + DISCOUNT.code + ' at checkout for ' + DISCOUNT.pct + '% off';
      codeEl.classList.toggle('is-on', DISCOUNT.on);
    }

    addBtn.disabled = !count || needSize > 0;
    addBtn.textContent = !count ? 'Nothing selected'
      : needSize ? 'Choose a size to continue'
      : 'Add ' + count + ' to bag · ' + money(owed);

    /* say the quiet part: WHY the bundle is short */
    var offNames = rows.map(function (r, k) { return (r.autoOff || r.dead) ? L.items[k].name : null; })
                       .filter(Boolean);
    if (alertEl) {
      if (offNames.length) {
        var who = offNames.length === 1 ? offNames[0] : offNames.slice(0, -1).join(', ') + ' and ' + offNames[offNames.length - 1];
        var deadAll = rows.filter(function (r) { return r.dead; }).length === offNames.length;
        alertEl.hidden = false;
        alertEl.textContent = deadAll
          ? who + (offNames.length === 1 ? ' is' : ' are') + ' sold out, so ' +
            (offNames.length === 1 ? "it's" : "they're") + ' not included.'
          : who + (offNames.length === 1 ? " isn't" : " aren't") + ' available in ' +
            (applied || 'that size') + ' — ' + (offNames.length === 1 ? "it's" : "they're") +
            ' left out. Pick another size to add ' + (offNames.length === 1 ? 'it' : 'them') + ' back.';
      } else { alertEl.hidden = true; alertEl.textContent = ''; }
    }

    /* one trust line, under the button where the decision happens */
    var goal = (DATA.freeShipGoal || 0) * 100;
    noteEl.textContent = !count ? 'Pick at least one piece'
      : (goal && owed >= goal) ? 'Free shipping · 30-day free returns'
      : 'Free shipping over ' + money(goal) + ' · 30-day free returns';
  }

  /* ── in-sheet image viewer ────────────────────────────────────── */
  function openViewer(k) {
    var it = DATA.looks[cur] && DATA.looks[cur].items[k];
    if (!it || !iv) return;
    var imgs = (it.images && it.images.length) ? it.images : (it.image ? [it.image] : []);
    if (!imgs.length) return;
    ivName.textContent = it.name;
    if (ivRev) {
      var ra = parseFloat(it.rating), rn = parseInt(it.reviews, 10);
      if (ra > 0 && rn > 0) {
        ivRev.hidden = false;
        ivRev.setAttribute('aria-label', reviewsLabel(ra, rn));
        ivRev.innerHTML = starsMarkup(ra) +
          '<span class="n">' + rn + ' Review' + (rn === 1 ? '' : 's') + '</span>';
      } else { ivRev.hidden = true; ivRev.innerHTML = ''; }
    }
    ivStrip.innerHTML = imgs.map(function (u, i) {
      return '<figure><img src="' + esc(u) + '" alt="" loading="' + (i ? 'lazy' : 'eager') + '"></figure>';
    }).join('');
    ivDots.innerHTML = imgs.length > 1
      ? imgs.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') : '';
    ivStrip.scrollLeft = 0;

    /* About this style + Fabric, parsed from the product's own description by
       snippets/nama-creator-piece-details.liquid — the same source the PDP
       Details and Composition accordions read. */
    if (ivInfo) {
      var d = it.detail || {};
      var html = '';
      if (d.about && d.about.length) {
        html += '<section class="ncl-iv-sec"><h4>About this style</h4><ul>' +
          d.about.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') +
          '</ul></section>';
      }
      if (it.fabric || d.composition) {
        html += '<section class="ncl-iv-sec"><h4>Fabric</h4>' +
          (it.fabric ? '<p class="fab">' + esc(it.fabric) + '</p>' : '') +
          (d.composition ? '<p class="comp">' + esc(d.composition) + '</p>' : '') +
          '</section>';
      }
      ivInfo.innerHTML = html;
    }
    if (ivScroll) ivScroll.scrollTop = 0;
    iv.hidden = false;
    requestAnimationFrame(function () { iv.classList.add('on'); });
    track('image_view', { product: it.name });
  }
  function closeViewer() {
    if (!iv || iv.hidden) return;
    iv.classList.remove('on');
    setTimeout(function () { iv.hidden = true; ivStrip.innerHTML = ''; }, 260);
  }
  if (ivStrip) {
    ivStrip.addEventListener('scroll', function () {
      var w = ivStrip.clientWidth || 1;
      var i = Math.round(ivStrip.scrollLeft / w);
      ivDots.querySelectorAll('i').forEach(function (d, n) { d.classList.toggle('on', n === i); });
    }, { passive: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ncl-look]');
    if (opener) { e.preventDefault(); openLook(+opener.getAttribute('data-ncl-look')); return; }
    if (e.target.closest('[data-ncl-iv-close]')) { closeViewer(); return; }
    if (e.target.closest('[data-ncl-sh-close]') || e.target === scrim) { closeSheet(); return; }
    if (!sheet.contains(e.target)) return;

    var thumb = e.target.closest('[data-ncl-img]');
    if (thumb) { openViewer(+thumb.closest('.ncl-it').getAttribute('data-ncl-k')); return; }

    var sel = e.target.closest('[data-ncl-szsel]');
    if (sel) {
      var ks = +sel.closest('.ncl-it').getAttribute('data-ncl-k');
      rows[ks].open = !rows[ks].open;
      sync(); return;
    }

    var sz = e.target.closest('.ncl-szs button');
    if (sz && !sz.disabled) {
      var k = +sz.closest('.ncl-it').getAttribute('data-ncl-k');
      rows[k].size = sz.getAttribute('data-ncl-sz');
      rows[k].open = false;
      if (rows[k].autoOff) { rows[k].included = true; rows[k].autoOff = false; }
      track('size_override', { size: rows[k].size });
      sync(); return;
    }

    var inc = e.target.closest('[data-ncl-inc]');
    if (inc && !inc.disabled) {
      var k2 = +inc.closest('.ncl-it').getAttribute('data-ncl-k');
      rows[k2].included = !rows[k2].included;
      if (rows[k2].included) {
        rows[k2].autoOff = false;
        if (!rows[k2].size) rows[k2].open = true;   // it needs a size — show the chips
      }
      track('piece_toggle', { included: rows[k2].included });
      sync(); return;
    }

    if (e.target.closest('[data-ncl-use-hers]')) {
      if (cur == null) return;
      var used = applyHerSizes();
      if (!used.length) return;
      rows.forEach(function (r) { r.open = false; });
      track('use_her_size', { sizes: used.join(',') });
      sync(); return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (iv && !iv.hidden) { closeViewer(); return; }
    if (sheet.classList.contains('on')) closeSheet();
  });

  addBtn.addEventListener('click', function () {
    if (addBtn.disabled || cur == null) return;
    var L = DATA.looks[cur];
    var items = [];
    L.items.forEach(function (it, k) {
      if (!rows[k].included) return;
      var v = variantFor(it, k);
      if (v) items.push({ id: v.id, quantity: 1 });
    });
    if (!items.length) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      /* the cart now has contents, so this is the first moment the discount
         can actually be judged — keep the page honest either way */
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (c) { return c.json(); })
        .then(function (cart) { auditCart(cart); paintDiscount(); })
        .catch(function () {});
    }).then(function () {
      closeSheet();
      toast.textContent = items.length + (items.length === 1 ? ' piece' : ' pieces') + ' added to your bag';
      toast.classList.add('on');
      setTimeout(function () { toast.classList.remove('on'); }, 2600);
      track('look_added', { look: L.title, pieces: items.length, discounted: DISCOUNT.on });
      if (window.NamaCart) window.NamaCart.open();
    }).catch(function () {
      addBtn.disabled = false;
      addBtn.textContent = 'Try again';
      noteEl.textContent = 'Something went wrong — please try again';
    });
  });

  initDiscount();

  /* ── card meta: swap the swatch row for her credit ────────────── */
  /* Shane 2026-07-31: colour dots are noise on a creator page — that slot
     becomes "<avatar> Mariana's pick". Done in JS because the swatch row is
     rendered inside the shared product-thumbnail snippet; if this fails the
     swatches simply remain (graceful). */
  (function () {
    var first = DATA.creatorFirst;
    if (!first) return;
    var avatar = DATA.avatar;
    root.querySelectorAll('.ncl-card').forEach(function (card) {
      var slot = card.querySelector('.cross-product-swatches');
      var meta = document.createElement('span');
      meta.className = 'ncl-meta';
      /* "Mariana wears S" beats "Mariana's pick": the same slot, but it
         answers the question the shopper actually has. Blank for pieces where
         a size would be a guess (accessories) — those keep the credit. */
      var w = card.getAttribute('data-ncl-wears');
      var line = w ? first + ' wears ' + w : first + '\u2019s pick';
      meta.innerHTML = (avatar ? '<img src="' + avatar + '" alt="" loading="lazy" width="44" height="44">' : '') +
        '<span>' + line.replace(/</g, '&lt;') + '</span>';
      if (slot) { slot.parentNode.replaceChild(meta, slot); }
      else {
        var cap = card.querySelector('.thumbnail__caption');
        if (cap) cap.insertBefore(meta, cap.firstChild);
      }
    });
  })();

  /* ── card rating: stars + the real Judge.me count ─────────────── */
  /* Own SVG stars, never .jdgm-star — that renders through the JudgemeStar
     icon font and custom.css's blanket font-family override turns it into
     letterforms. Same shape the PDP head draws, so the two agree.
     Separate pass from the meta line above so a card still gets its rating if
     the creator credit is missing. */
  (function () {
    root.querySelectorAll('.ncl-card').forEach(function (card) {
      var avg = parseFloat(card.getAttribute('data-ncl-rating'));
      var n = parseInt(card.getAttribute('data-ncl-reviews'), 10);
      if (!(avg > 0) || !(n > 0)) return;            // no reviews: no empty stars
      var cap = card.querySelector('.thumbnail__caption');
      if (!cap) return;

      var rev = document.createElement('span');
      rev.className = 'ncl-rev';
      rev.setAttribute('aria-label', reviewsLabel(avg, n));
      rev.innerHTML = starsMarkup(avg) +
        '<span class="n">' + n + ' Review' + (n === 1 ? '' : 's') + '</span>';

      var meta = cap.querySelector('.ncl-meta');
      if (meta) cap.insertBefore(rev, meta.nextSibling);
      else cap.insertBefore(rev, cap.firstChild);
    });
  })();

  /* ── favourites filter (show/hide, no re-render) ──────────────── */
  /* One bar per favourites set (the page's own plus any per-ad override), and
     each filters only the cards in ITS set — a page-wide query would let a
     hidden variant's chips reach the visible grid. */
  root.querySelectorAll('[data-ncl-filt]').forEach(function (filt) {
    var scope = filt.closest('[data-ncl-fav]') || root;
    filt.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-ncl-cat]');
      if (!b) return;
      var cat = b.getAttribute('data-ncl-cat');
      filt.querySelectorAll('button').forEach(function (x) {
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      scope.querySelectorAll('[data-ncl-ptype]').forEach(function (card) {
        card.classList.toggle('ncl-hide', cat !== 'All' && card.getAttribute('data-ncl-ptype') !== cat);
      });
    });
  });

  /* ── mobile sticky CTA — after the hero CTA scrolls off the top ── */
  var sticky = root.querySelector('[data-ncl-sticky]');
  var heroCta = root.querySelector('[data-ncl-hero-cta]');
  if (sticky && heroCta) {
    new IntersectionObserver(function (en) {
      sticky.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(heroCta);
  }
})();
